module.exports = __webpack_public_path__ + "img/lochgestaltung.8b0491c1.jpg";